'use client';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { PropsWithClassname } from '@/app/types';

import '@/app/components/RewardBox/rewardBoxStyle.css';

interface RewardItemQuantityProps extends PropsWithClassname {
  itemsRemaining: number;
  totalItems: number;
}

const RewardItemQuantity = ({ itemsRemaining, totalItems, className }: RewardItemQuantityProps) => {
  const { t } = useTranslation();

  return (
    <span
      className={classNames(
        className,
        'inline-block bg-secondary-light font-medium text-primary-mid uppercase nowrap rounded text-[11px] leading-[24px] tracking-[4px] pt-[3px] pb-[2px] px-[12px]',
      )}
    >
      {t('components.RewardBox.remaining', { total: totalItems, remaining: itemsRemaining })}
    </span>
  );
};

export default RewardItemQuantity;
